import styled, { css } from "styled-components";

const edgeFade = css`
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    z-index: 1;
    pointer-events: none;
  }

  &::before {
    top: 0;
    height: 34%;
    background: linear-gradient(
      180deg,
      rgba(2, 8, 15, 0.92) 0%,
      rgba(10, 36, 60, 0.58) 48%,
      rgba(8, 19, 31, 0) 100%
    );
  }

  &::after {
    bottom: 0;
    height: 34%;
    background: linear-gradient(
      180deg,
      rgba(4, 10, 18, 0) 0%,
      rgba(6, 12, 21, 0.62) 52%,
      rgba(3, 7, 13, 0.94) 100%
    );
  }
`;

export const Card = styled.a`
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: ${(p) => (p.$image ? "612 / 918" : "281 / 367")};
  overflow: clip;
  border-radius: 6px;
  background: ${(p) =>
    p.$brand
      ? "radial-gradient(120% 90% at 50% 32%, #214587 0%, #052752 78%)"
      : p.$image
        ? "#000"
        : "#071525"};
  border: ${(p) => (p.$brand ? "1px solid rgba(45, 120, 255, 0.45)" : "none")};
  text-decoration: none;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;

  ${(p) => !p.$brand && !p.$image && edgeFade}
`;

export const Video = styled.video`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: 50% 42%;
`;

export const BgImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center;
`;

export const TextLayer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 8px 8px 0;
  text-align: center;
  color: #fff;
  pointer-events: none;
`;

export const BrandLayer = styled.div`
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 10px 60px;
  color: #fff;
  pointer-events: none;

  @media (max-width: 768px) {
    padding-bottom: 50px;
  }
`;

export const BrandCenter = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-align: center;
`;

export const BrandLogo = styled.img`
  width: min(72%, 160px);
  height: auto;
  margin-bottom: 4px;
  filter: drop-shadow(0 4px 14px rgba(6, 24, 48, 0.55));
`;

export const FooterLogo = styled.img`
  position: absolute;
  left: 50%;
  bottom: 58px;
  z-index: 2;
  height: 18px;
  width: auto;
  transform: translateX(-50%);
  pointer-events: none;
  filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.45));

  @media (max-width: 768px) {
    height: 14px;
    bottom: 48px;
  }
`;

export const AdLabel = styled.span`
  align-self: flex-start;
  color: rgba(77, 157, 255, 0.88);
  font-family: Figtree, sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: 0.2px;
`;

export const Title = styled.span`
  color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 17px;
  font-weight: 800;
  line-height: 1.08;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.34);

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const Subtitle = styled.span`
  color: rgba(220, 235, 255, 0.82);
  font-family: Figtree, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.1;

  @media (max-width: 768px) {
    font-size: 10px;
  }
`;

export const CtaPill = styled.span`
  position: absolute;
  left: 50%;
  bottom: 12px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  border-radius: 999px;
  border: 1px solid rgba(120, 181, 255, 0.68);
  background:
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.18) 0%,
      rgba(255, 255, 255, 0) 100%
    ),
    #3f91ff;
  color: #fff;
  font-family: Figtree, sans-serif;
  font-size: 13px;
  font-weight: 800;
  line-height: 1;
  white-space: nowrap;
  transform: translateX(-50%);
  box-shadow:
    0 8px 18px rgba(23, 101, 216, 0.38),
    inset 0 1px 2px rgba(255, 255, 255, 0.22),
    inset 0 -8px 12px -8px rgba(177, 217, 255, 0.34);
  transition:
    transform 0.16s ease,
    filter 0.16s ease;

  ${Card}:hover & {
    transform: translateX(-50%) translateY(-1px);
    filter: brightness(1.06);
  }

  ${Card}:active & {
    transform: translateX(-50%) scale(0.98);
    filter: brightness(1.08);
  }

  @media (max-width: 768px) {
    height: 30px;
    padding: 0 14px;
    font-size: 11px;
    bottom: 10px;
  }
`;
